import { env } from "."

export const list = [
    {
        id: 1,
        title: 'Правила игры',
        text: 'Niu Niu — карточная игра на одной колоде из 52 карт без джокеров. За столом три бокса, и каждый из них открыт всем игрокам одновременно: один игрок может играть на всех трёх боксах разными ставками. Перед раздачей игрок делает до трёх независимых друг от друга ставок — NORMAL BET, DOUBLE BET и SUPER DOUBLE. После раздачи никаких решений игрок не принимает: дилер раздаёт по пять карт трём боксам и себе, вскрывает свои карты, и каждый бокс сравнивается только с рукой дилера. Ничьих в игре не бывает — всегда выигрывает либо бокс, либо дилер.',
        content:
            <div className="content">
                <p><b>NIU NIU</b><br /><br />Цель игры — собрать из пяти карт комбинацию сильнее, чем у дилера.</p>

                <p>Используется одна колода из 52 карт без джокеров. За столом три бокса, и ни один из них ни за кем не закреплён: на один и тот же бокс могут ставить сразу несколько игроков, а один игрок может играть на всех трёх разными ставками.</p>

                <p>До раздачи игрок делает до трёх независимых ставок: <b>NORMAL BET</b>, <b>DOUBLE BET</b> и <b>SUPER DOUBLE</b>. Можно поставить одну из них, любые две или все три — они не связаны между собой и рассчитываются каждая по своей колонке таблицы выплат.</p>

                <p><b>Удержание ставки.</b> Проигрыш в этой игре может превышать номинал ставки, поэтому при её постановке со счёта сразу удерживается максимально возможная сумма проигрыша: одна ставка на NORMAL BET, пять на DOUBLE BET и пятнадцать на SUPER DOUBLE. Всё, что раздача не забрала, возвращается на счёт сразу после вскрытия карт дилера — вместе с выигрышем, если он есть.</p>

                <p><b>Карта старта раздачи.</b> Перед раздачей дилер вытаскивает одну карту и отсчитывает по ней место, с которого начнётся раздача, начиная со своего бокса: туз — 1, валет — 11, дама — 12, король — 13. Если очков больше, чем мест за столом, отсчёт продолжается по кругу. Эта карта не входит ни в одну руку и ни с чем не сравнивается.</p>

                <p>Дальше карты раздаются по одной по часовой стрелке, по пять на каждый бокс и дилеру. Карты дилера закрыты и открываются после того, как все карты розданы. Обмена карт, покупки и страховки нет.</p>

                <p>Каждый бокс сравнивается <b>только</b> с рукой дилера — другие боксы к этому отношения не имеют. «Без игры» и «стей» не бывает: всегда выигрывает либо бокс, либо дилер.</p>
            </div>
    },
    {
        id: 2,
        title: 'Комбинации',
        content:
            <div className="content">

                <p><b>Как считаются очки.</b> Картинки (валет, дама, король) и десятки стоят ноль очков, туз — одно очко, остальные карты — по номиналу. При подсчёте десятки отбрасываются, считаются только единицы: 8+4+8 = 20 = 0, 7+3+10 = 20 = 0.</p>

                <p><b>Ню</b> — это ноль очков на трёх картах из пяти. То, что стоят две оставшиеся карты, и даёт название комбинации.</p>

                <p>
                    <b>Ню Ню</b> — ноль на трёх картах и ноль на двух оставшихся. Например, 9+7+4 / 8+2.<br />
                    <b>Ню 9</b> — ноль на трёх и девять на двух. Например, 9+6+5 / 7+2.<br />
                    Так же определяются комбинации от <b>Ню 8</b> до <b>Ню 1</b>.
                </p>

                <p><b>Пять картинок</b> — все пять карт валеты, дамы и короли. Туз картинкой не считается.</p>

                <p><b>Каре</b> — четыре карты одного номинала и любая пятая.</p>

                <p><b>Старшинство комбинаций, от сильной к слабой:</b><br />
                    Каре &gt; Пять картинок &gt; Ню Ню &gt; Ню 9 &gt; Ню 8 &gt; Ню 7 &gt; Ню 6 &gt; Ню 5 &gt; Ню 4 &gt; Ню 3 &gt; Ню 2 &gt; Ню 1 &gt; Нет игры.
                </p>

                <p><b>Старшинство карт.</b> При одинаковых комбинациях сравнение идёт по старшей карте из пяти:<br />
                    К &gt; Д &gt; В &gt; 10 &gt; 9 &gt; 8 &gt; 7 &gt; 6 &gt; 5 &gt; 4 &gt; 3 &gt; 2 &gt; Т.
                </p>

                <p>Туз здесь — <b>младшая</b> карта, поэтому каре двоек старше каре тузов.</p>

                <p>Если совпадают номиналы всех карт, сравнение идёт по масти старшей карты: ♠ &gt; ♥ &gt; ♣ &gt; ♦. Две руки из одной колоды не могут совпасть полностью, поэтому победитель определяется всегда.</p>

                <p><b>Как выкладываются карты.</b> Если есть комбинация, три карты «Ню» выдвигаются вверх, а две оставшиеся остаются снизу. При каре вверху четыре карты, внизу одна. Если комбинации нет — вверх выдвигается только старшая карта. Карты дилера всегда выкладываются в один ряд, комбинация в нём отделяется.</p>

                <p><b>Половина на Ню 7.</b> Выигрыш с комбинацией «Ню 7» оплачивается в половинном размере: NORMAL BET — 0,5:1, DOUBLE BET — 1:1, SUPER DOUBLE — 3,5:1. Проигрыш комбинации «Ню 7» у дилера при этом удерживается полностью: 1 ставка на NORMAL BET, 2 на DOUBLE BET и 7 на SUPER DOUBLE.</p>

            </div>
    },
    {
        id: 3,
        title: 'Делайте ставки',
        content:
            <div className="content">

                Панель «ЛИМИТЫ СТАВОК» отображает минимальные и максимальные разрешенные лимиты ставок за столом, которые могут время от времени меняться. Откройте «Лимиты ставок», чтобы проверить свои текущие лимиты.
                <br /><br />
                Niu Niu 1 - 1 000 $
                <br /><br />
                Для участия в игре вам потребуется достаточное количество средств, необходимое для покрытия ставок. Ваш текущий БАЛАНС отображается на экране.
                <br /><br />
                Ваши средства - БАЛАНС 100 000 $
                <br /><br />
                В иммерсивном виде ТАЙМЕР показывает оставшееся время для размещения ставок. По истечении этого времени ставки больше не принимаются.
                <br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/choiseTimer.png`} alt="bet-ante" />
                <br /><br />
                Индикатор «ОТОБРАЖЕНИЕ ФИШЕК» позволяет выбирать достоинство каждой фишки, которую захотите разместить в виде ставки. Для выбора доступны только те фишки, номинал которых может быть покрыт вашим текущим балансом.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/rules/chips.svg`} alt="chips" />
                <br /><br />
                После выбора фишки сделайте ставку, нажав на соответствующее место для ставки на игровом столе. При каждом нажатии на место для ставок сумма вашей ставки увеличивается на стоимость выбранной фишки или до максимально допустимого лимита для выбранного вами типа ставки. После размещения максимально допустимого лимита ставки дополнительные средства не принимаются, а над вашей ставкой появится сообщение с уведомлением о размещении максимальной ставки.
                <br /><br />
                <img className='rule-img-big widget' src={`/images/rates.png`} alt="bet-ante" />
                <br /><br />
                ПРИМЕЧАНИЕ: Пожалуйста, не сворачивайте окно браузера и не открывайте другие вкладки в своем браузере, пока активно время размещения ставок и ставки размещаются на столе. Такие действия могут быть расцедены как выход из игры, и, следовательно, ваши ставки будут отклонены в этом раунде игры.
                <br /><br />
                Кнопка «ПОВТОРИТЬ» позволяет повторить все ставки из предыдущего раунда игры. Эта кнопка остается активной до тех пор, пока не будет размещена первая фишка.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/repeat.svg`} alt="btn" />
                <br /><br />
                Кнопка «УДВОИТЬ» (2×) становится доступной после размещения ставки. С каждым щелчком/нажатием все ваши ставки удваиваются вплоть до максимального предела. Обратите внимание, что вам необходимо иметь достаточное количество средств на счете для удвоения ВСЕХ ваших размещенных ставок.
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/double.svg`} alt="btn" />
                <br /><br />
                Кнопка «ОТМЕНА» позволяет удалить последнюю размещенную ставку.
                <br /><br />
                Повторное нажатие кнопки «ОТМЕНА» позволяет отменить ставки по одной в обратном порядке их размещения. Чтобы удалить все свои ставки, удерживайте нажатой кнопку «ОТМЕНА».
                <br /><br />
                <img className='rule-button-img' src={`${env.mediapoint}/images/rules/cancel.svg`} alt="btn" />
                <br /><br />
                Индикатор «ОБЩАЯ СТАВКА» отображает общую сумму ставок, размещенных в текущем раунде.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/totalBet.svg`} alt="total" />
                <br /><br />
                Примите решение
                <br /><br />
                После раздачи ваших карт появится ваша комбинация карт и окно
                <br /><br />
                <img className='rule-img-big widget' src={`/images/ultimate-game.png`} alt="game" />
                <br /><br />
                <img className='rule-img-big widget' src={`/images/ultimate-buttons.png`} alt="game" />
                <br /><br />
                Для CHECK надо нажать окно
                <br /><br />
                <img className='rule-img-big' src={`/images/check.png`} alt="sixth" />
                <br /><br />
                Вы должны решить, что нажать: «BET» для продолжения раунда игры или «ПАС» для завершения раунда игры с потерей размещенных ставок.
                <br /><br />
                <img className='rule-img-big' src={`/images/bet-pass.png`} alt="btn" />
                <br /><br />
                При нажатии на кнопку «BET» вы продолжаете играть и делаете ставку «BET», Ставка «BET» будет автоматически размещена в месте для ставки «BET».
                <br /><br />
                После щелчка/нажатия кнопки «ПАС» вы потеряете свою ставку АНТЕ и BLIND.
                Вы сможете наблюдать за ходом игры, но не сможете в ней участвовать. Чтобы сделать новые ставки, вам придется дождаться следующего раунда.
                <br /><br />
            </div>
    },
    {
        id: 4,
        title: 'Чат',
        content:
            <div className="content">
                Вы можете обмениваться сообщениями с ведущим игры и другими игроками. Введите свое сообщение в окне ЧАТА. Для отправки сообщения нажмите Ввод или стрелочку, расположенную в поле.
                <br /><br />
                Для игроков, которые некорректно ведут себя в чате, оскорбляют ведущего и других игроков, используют неуместные и/или оскорбительные выражения, доступ к чату будет закрыт.
                <br /><br />
                Используйте кнопку «ЧАТ» для увеличения или закрытия окна чата.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/chat.svg`} alt="chips" />
            </div>
    },
    {
        id: 5,
        title: 'Номер игры',
        content:
            <div className="content">
                Каждый раунд игры идентифицируется уникальным НОМЕРОМ ИГРЫ.
                <br /><br />
                <img className='rule-img border' src={`${env.mediapoint}/images/rules/game-number.svg`} alt="number" />
                <br /><br />
                Пожалуйста, используйте этот номер (или сделайте снимок экрана с номером игры), если вы хотите обратиться в Службу поддержки с вопросами относительно определенного раунда.
            </div>
    },
    {
        id: 6,
        title: 'Звук',
        content:
            <div className="content">
                Кнопка «ЗВУК» включает/выключает все звуки игры и голоса.
                Примите к сведению, что в случае смены стола все звуки включатся автоматически.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/audio-on.svg`} alt="chips" />
                <br /><br />
                Вы можете изменить настройки звука, нажав кнопку «НАСТРОЙКИ» и выбрав вкладку ЗВУК,
            </div>
    },
    {
        id: 7,
        title: 'История игр',
        content:
            <div className="content">
                С помощью кнопки «ИСТОРИЯ» можно открыть окно, в котором будут отображены все сыгранные вами раунды игры и их результаты.
                <br /><br />
                <img className='rule-img' src={`${env.mediapoint}/images/control-buttons/history.svg`} alt="chips" />
                <br /><br />
                Вы можете просматривать свою игровую активность с помощью . следующего:
                <br /><br />
                • ИСТОРИЯ УЧЕТНОЙ ЗАПИСИ - отображает всю историю вашей учетной записи в виде списка дат, игр, сумм ставок и выплат.
                <br /><br />
                Последний завершенный раунд отображается в самом верху списка.
                <br /><br />
                • ИСТОРИЯ ИГР -- после щелчка/нажатия на определенную игру в столбце ИГРА отображает вашу историю, связанную с определенной игрой.
            </div>
    },
    {
        id: 8,
        title: 'Действия в случае сбоя',
        content:
            <div className="content">
                При сбоях в игре, игровой системе или процедуре игры раунд временно
                приостанавливается, а ведущий игры уведомляет об этом сервис-менеджера. Вы и
                другие игроки увидят сообщение в чате или всплывающее сообщение на экране о том,
                что данный вопрос рассматривается. Если менеджер сможет незамедлительно
                устранить ошибку, раунд игры продолжится, как обычно. В случае отсутствия
                возможности незамедлительного устранения раунд игры аннулируется, а изначальные
                ставки подлежат возмещению всем игрокам, принявшим в нем участие.            </div>
    },
    {
        id: 9,
        title: 'Политика отключения',
        content:
            <div className="content">
                В случае отключения от игры до истечения времени для размещения ставок любые
                сделанные ставки признаются недействительными и возвращаются вам. В случае
                отключения после истечения времени для размещения ставок, сделанные ставки
                признаются действительными и разыгрываются без вашего участия. Результаты
                розыгрыша ставки можно посмотреть в окне «История» после повторного
                подключения.
            </div>
    }
]